import React, { Component } from 'react';
import { connect } from 'react-redux'
import { toggleIntro, loadMy, togglePostForm, updatePostInput } from './actions/user'
import { createPost } from "./actions/posts";
import {Icon, Form, Input, Checkbox, Button} from 'antd'
import {setDocumentHeight} from "./utils";
import pointx from './images/pointx.png'
import maskEmpty from './images/mask-empty.png'
import maskFill from './images/mask-fill.png'
import point1 from './images/point1.png'
import './PostForm.css'
const FormItem = Form.Item
const TextArea = Input.TextArea


class PostForm extends Component {

  componentDidMount(){
    this.props.loadMy()
  }

  handleSubmit = (e) => {
    let {createPost} = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.form.resetFields()
        this.textarea.blur()
        createPost(values)
      }
    });
  }

  handleAnonymous = (e) =>{
    let {updatePostInput} = this.props
    updatePostInput({
      anonymous: e.target.checked
    })
  }

  handleContent = (e) =>{
    let {updatePostInput} = this.props
    console.log(e.target.value)
    updatePostInput({
      content: e.target.value
    })
  }

  renderPostForm(){
    const {toggleIntro, user, postInput, togglePostForm, postFormOpening} = this.props
    const {
      getFieldDecorator,
    } = this.props.form;
    return <div>
      <div className={"post-form-header"} onClick={togglePostForm}>
        <Icon type={`${postFormOpening?'minus':'plus'}`} style={{
          fontSize: 28,
          color: 'white',
          lineHeight: 1,
          height: 28,
          padding: 6
        }} className={"post-form-add"}/>
        <div className={"post-form-points"} style={{
          backgroundImage: `url(${pointx})`
        }}>
          {user.points || 0}
        </div>
      </div>
      <Form
        className={"post-form-body"}
        onSubmit={this.handleSubmit}
      >
        <FormItem>
          {getFieldDecorator('content', {
            value: postInput.content || '',
            rules: [{ required: true, message: '请输入发布内容' }],
          })(
            <TextArea
              ref={ref=>{this.textarea=ref}}
              placeholder="发起讨论「+」"
              onChange={this.handleContent}
              onBlur={()=>{
                setDocumentHeight()
              }}
            />
          )}
        </FormItem>
        <FormItem
          className={"post-form-anonymous"}
        >
          {getFieldDecorator('anonymous', {
            valuePropName: 'checked',
            value: postInput.anonymous || false,
          })(
            <div>
              <Checkbox className={"anonymous-mask"}  style={{
                backgroundImage: `url(${postInput.anonymous?maskFill:maskEmpty})`
              }} onChange={this.handleAnonymous}
              />
              <div className={'post-form-cost'} style={{
                backgroundImage: `url(${point1})`
              }}>-10</div>
              <Icon type="question-circle" className={"post-form-intro"}
                onClick={toggleIntro}
              />
            </div>
          )}
        </FormItem>
        <FormItem
          className={"comment-form-send"}
        >
          <Button
            type="primary"
            htmlType="submit"
            className="comment-form-send-button"
          >发送</Button>
        </FormItem>
      </Form>
    </div>
  }

  render() {
    const {loadingMy, loadingMyError, postFormOpening} = this.props
    return <div className={`post-form-container ${postFormOpening?'post-form-open':'post-form-closed'}`}>
      {
        loadingMy && <div className="post-form-load-bar">
          <div className="post-form-bar"></div>
          <div className="post-form-bar"></div>
          <div className="post-form-bar"></div>
        </div>
      }
      {
        loadingMyError && <div className={"loading-user-error"}>
          {loadingMyError}
        </div>
      }
      {
        (!loadingMy && !loadingMyError) && this.renderPostForm()
      }
    </div>
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user.my,
    postInput: state.user.postInput,
    loadingMy: state.user.loadingMy,
    loadingMyError: state.user.loadingMyError,
    postFormOpening: state.user.postFormOpening,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadMy: ()=>dispatch(loadMy()),
    togglePostForm: ()=>dispatch(togglePostForm()),
    createPost: (post)=>dispatch(createPost(post)),
    updatePostInput: (post)=>dispatch(updatePostInput(post)),
    toggleIntro: ()=>dispatch(toggleIntro())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(PostForm))




// WEBPACK FOOTER //
// ./src/PostForm.js